export default {
  title: 'Upload your full unabbreviated accounts'
};
